import { useQuery } from '@tanstack/react-query';
import { servicesApi } from '../api/servicesApi';
import { Service, ServiceFilters, ServiceSortOption } from '../types/service.types';

/**
 * Hook for fetching all services with filters and sorting
 */
export const useServices = (filters: ServiceFilters, sortBy: ServiceSortOption) => {
  return useQuery<Service[], Error>({
    queryKey: ['services', filters, sortBy],
    queryFn: () => servicesApi.getAll(filters, sortBy),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
  });
};

/**
 * Hook for fetching a single service by slug
 */
export const useService = (slug: string) => {
  return useQuery<Service | null, Error>({
    queryKey: ['service', slug],
    queryFn: () => servicesApi.getBySlug(slug),
    enabled: !!slug,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};

/**
 * Hook for fetching a single service by ID
 */
export const useServiceById = (id: string) => {
  return useQuery<Service | null, Error>({
    queryKey: ['service', 'id', id],
    queryFn: () => servicesApi.getById(id),
    enabled: !!id,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};
